export const CELEBRATION_PURCHASE = {
  YES: 'yes',
  NO: 'no',
  LATER: 'later',
} as const

export type CelebrationPurchase =
  (typeof CELEBRATION_PURCHASE)[keyof typeof CELEBRATION_PURCHASE]

export type FuneralPlanItemSummary = {
  id?: string
  slug: string
}

export type CelebrationInterestStatus = 'legacy' | 'later' | 'no'

const isCelebrationItem = (slug: string): boolean =>
  slug.startsWith('celebration_')

const isCelebrationUrnItem = (slug: string): boolean => slug.startsWith('urn_')

export const getCelebrationItems = (
  items: FuneralPlanItemSummary[] = []
): FuneralPlanItemSummary[] =>
  items.filter((item) => isCelebrationItem(item.slug))

export const hasActiveCelebration = (
  items: FuneralPlanItemSummary[] = []
): boolean => getCelebrationItems(items).length > 0

export const getPlanUrnType = (
  items: FuneralPlanItemSummary[] = []
): string | undefined =>
  items
    .find((item) => isCelebrationUrnItem(item.slug))
    ?.slug.replace('urn_', '')

export const getCelebrationInterestStatus = ({
  items = [],
  celebrationPurchase,
}: {
  items?: FuneralPlanItemSummary[]
  celebrationPurchase?: CelebrationPurchase | '' | null
}): CelebrationInterestStatus | 'purchased' => {
  if (hasActiveCelebration(items)) return 'purchased'
  if (celebrationPurchase === CELEBRATION_PURCHASE.LATER) return 'later'
  if (celebrationPurchase === CELEBRATION_PURCHASE.NO) return 'no'
  return 'legacy'
}
